// extracted by mini-css-extract-plugin
module.exports = {"back":"CreateRequestHeader_back__2Qx5X"};